export const PROD_MEDIA_SERVER = 'https://d16qt3wv6xm098.cloudfront.net/';
export const S3_BUCKET_URL = 'https://osmose-it.s3.amazonaws.com/';
export const CLOUDFRONT_ASSET_URL =
  'https://d3cdo0emj8d2qc.cloudfront.net/assets/';

export const assets = {
  note: `${CLOUDFRONT_ASSET_URL}SSqHK02PQmmSBa27cg51CAoEStG2sjqh.svg`,
  robot: `${CLOUDFRONT_ASSET_URL}RkmM7MOKRM2I3UvMNRMx2W9-TQa6iIBr.png`,
  kidney: `${CLOUDFRONT_ASSET_URL}6504b216911d94193f5c0470a35eba154944354d.png`,
  logo: `${CLOUDFRONT_ASSET_URL}TYtc0WCQSuq2XwZA7KugnZ1pTR_IkYuC.png`,
  logoIcon: `${CLOUDFRONT_ASSET_URL}71e7e522444440761e2b1a6bba54c22b744be3e4.png`,
} as const;

export const PERCENT_THRESHOLD = 80;

export const VIDEO_WATCHED_BROADCAST = 'video-watched-update';
export const VIDEO_WATCHED_EVENT = 'VIDEO_WATCHED_UPDATED';

export default {
  PROD_MEDIA_SERVER,
  S3_BUCKET_URL,
  CLOUDFRONT_ASSET_URL,
};
